module.exports = __webpack_public_path__ + "img/x2.72d73248.jpg";